// @ts-check

import { useInfiniteQuery } from '@tanstack/vue-query';

import { showSingleFeed } from '@/api/feed';
import { convertToStaleTime, createQueryKey } from '@/composables/vue-query/util';

export const SINGLE_FEED_QUERY_KEY = createQueryKey(['single-feed']);

export const useSingleFeed = () => {
  const queryResult = useInfiniteQuery({
    queryKey: SINGLE_FEED_QUERY_KEY,
    queryFn: async ({ pageParam }) => {
      const singleFeed = await showSingleFeed({ page: pageParam });

      return singleFeed;
    },
    staleTime: convertToStaleTime({ minutes: 60 }),
    retry: false,
    // @ts-ignore
    getNextPageParam: (lastPage) => lastPage.nextPagination,
  });

  return { singleFeed: queryResult.data, ...queryResult };
};

/** @typedef { import('@tanstack/vue-query').QueryClient } QueryClient */

/**
 * Resets the single feed query in the query cache.
 * @param {Object} options - The options object.
 * @param {QueryClient} options.queryClient - The query client instance.
 */
export const resetSingleFeed = ({ queryClient }) => {
  queryClient.resetQueries({ queryKey: SINGLE_FEED_QUERY_KEY });
};
